/** Symbol payout definitions for Rush Fever 7s Deluxe */

export interface SymbolPayout {
  /** Symbol identifier */
  symbol: string;
  /** Payout for each streak length [1-match, 2-match, 3-match, 4-match, 5-match, 6-match] */
  payouts: readonly number[];
  /** Minimum streak length required for a payout */
  minStreak: number;
}

/**
 * Complete paytable from math model.
 * Indexed [1-match, 2-match, 3-match, 4-match, 5-match, 6-match].
 * PICa pays for 3+ matches. ALL others only pay for 4+ matches (3-match = 0).
 */
export const PAY_TABLE: readonly SymbolPayout[] = [
  { symbol: 'PICa', payouts: [0, 0, 7, 20, 50, 500], minStreak: 3 },
  { symbol: 'PICb', payouts: [0, 0, 0, 15, 30, 100], minStreak: 4 },
  { symbol: 'PICc', payouts: [0, 0, 0, 10, 20, 75], minStreak: 4 },
  { symbol: 'PICd', payouts: [0, 0, 0, 7, 15, 50], minStreak: 4 },
  { symbol: 'PICe', payouts: [0, 0, 0, 5, 10, 35], minStreak: 4 },
  { symbol: 'A', payouts: [0, 0, 0, 2, 5, 25], minStreak: 4 },
  { symbol: 'K', payouts: [0, 0, 0, 2, 5, 25], minStreak: 4 },
  { symbol: 'Q', payouts: [0, 0, 0, 2, 5, 25], minStreak: 4 },
  { symbol: 'J', payouts: [0, 0, 0, 2, 5, 25], minStreak: 4 },
  { symbol: 'T', payouts: [0, 0, 0, 2, 5, 25], minStreak: 4 },
  { symbol: 'SCATTER', payouts: [0, 0, 2, 4, 20, 0], minStreak: 3 },
] as const;

/** Lookup map for quick access by symbol name */
export const PAY_TABLE_MAP: ReadonlyMap<string, SymbolPayout> = new Map(
  PAY_TABLE.map((entry) => [entry.symbol, entry])
);

/** WILD has no standalone pay — it substitutes for all except SCATTER and Rush */
export const WILD_SYMBOL = 'WILD';
/** Rush has no line pay */
export const RUSH_SYMBOL = 'Rush';
/** SCATTER pays independently of ways */
export const SCATTER_SYMBOL = 'SCATTER';

/** Symbols that WILD can substitute for (all regular + card symbols) */
export const WILD_SUBSTITUTES_FOR: ReadonlySet<string> = new Set(
  PAY_TABLE.filter((e) => e.symbol !== 'SCATTER').map((e) => e.symbol)
);

/** Reels where WILD can appear (0-indexed): reels 2, 3, 4 only */
export const WILD_REEL_INDICES: ReadonlySet<number> = new Set([1, 2, 3]);
